import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface Props {
  from?: string;
  to?: string;
  onChange: (range: { from?: string; to?: string }) => void;
  /** Sufixo opcional ao label (ex: "(criado)") */
  label?: string;
}

// datetime-local exige formato 'YYYY-MM-DDTHH:mm' (sem segundos/timezone)
function toLocalInput(iso?: string): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const pad = (n: number) => n.toString().padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

function fromLocalInput(local: string): string | undefined {
  if (!local) return undefined;
  const d = new Date(local);
  if (Number.isNaN(d.getTime())) return undefined;
  return d.toISOString();
}

export function DateRangePicker({ from, to, onChange, label }: Props) {
  return (
    <div className="flex flex-col sm:flex-row gap-2">
      <div className="flex flex-col">
        <Label className="text-[10px] uppercase text-muted-foreground">De{label ? ` ${label}` : ''}</Label>
        <Input
          type="datetime-local"
          value={toLocalInput(from)}
          onChange={e => onChange({ from: fromLocalInput(e.target.value), to })}
          className="h-8 text-xs w-44"
        />
      </div>
      <div className="flex flex-col">
        <Label className="text-[10px] uppercase text-muted-foreground">Até{label ? ` ${label}` : ''}</Label>
        <Input
          type="datetime-local"
          value={toLocalInput(to)}
          onChange={e => onChange({ from, to: fromLocalInput(e.target.value) })}
          className="h-8 text-xs w-44"
        />
      </div>
    </div>
  );
}

// Helper para presets rapidos
export function presetRange(preset: 'last1h' | 'last24h' | 'last7d' | 'last30d'): { from: string; to: string } {
  const now = new Date();
  const to = now.toISOString();
  const ms = preset === 'last1h' ? 3600_000
    : preset === 'last24h' ? 86_400_000
    : preset === 'last7d'  ? 7 * 86_400_000
    : 30 * 86_400_000;
  return { from: new Date(now.getTime() - ms).toISOString(), to };
}
